import React from 'react'
import { formatTimeHorizon } from './timeHorizon.js'
import { Card, IconButton, Icon } from '../ui'
import { GoalStatusLabel } from './GoalStatusLabel.jsx'

const TYPE_BADGE = {
  delivery:    { background: '#e89a5d18', color: '#8a5a2a' },
  development: { background: '#3b82c418', color: '#1e4a7a' },
}

export function GoalCanvasCard({
  goal,
  ownerUserId,
  onSetStatusLabel,
  onNavigateGoal,
  onNavigateGoals,
  readOnly = false,
}) {
  const typeBadge = TYPE_BADGE[goal.goalType] || TYPE_BADGE.delivery
  const rollup = goal.rollup

  // Build rollup text
  let rollupText = null
  if (rollup && rollup.total > 0) {
    const onTrack = (rollup.onTrack || 0) + (rollup.done || 0)
    rollupText = `${onTrack}/${rollup.total} sub-goals on track`
  }

  return (
    <Card
      style={{
        padding: '10px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        minHeight: 160,
      }}
    >
      <div style={styles.top}>
        <span style={styles.title}>{goal.title}</span>
        <div style={styles.topRight}>
          {!readOnly ? (
            <GoalStatusLabel
              value={goal.statusLabel}
              onChange={(v) => onSetStatusLabel?.(goal.goalId, v)}
            />
          ) : (
            <GoalStatusLabel value={goal.statusLabel || goal.progressLabel} readOnly />
          )}
          {onNavigateGoal && (
            <IconButton ariaLabel="Open goal" title="Open goal" onClick={() => onNavigateGoal(goal.goalId)}>
              <Icon name="external-link" />
            </IconButton>
          )}
        </div>
      </div>

      {goal.description && <p style={styles.description}>{goal.description}</p>}

      <div style={styles.sub}>
        <span style={{ ...styles.typeBadge, ...typeBadge }}>{goal.goalType}</span>
        {goal.timeHorizon && <span style={styles.horizon}>{formatTimeHorizon(goal.timeHorizon)}</span>}
      </div>

      {rollupText && <span style={styles.rollup}>{rollupText}</span>}
    </Card>
  )
}

const styles = {
  top: { display: 'flex', alignItems: 'flex-start', gap: '8px', justifyContent: 'space-between' },
  title: { fontSize: '12px', fontWeight: 500, color: 'var(--text-primary)', lineHeight: 1.4, flex: 1 },
  topRight: { display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 },
  sub: { display: 'flex', alignItems: 'center', gap: '6px', marginTop: 'auto' },
  typeBadge: { fontSize: '10px', padding: '1px 6px', borderRadius: '8px' },
  horizon: { fontSize: '10px', color: 'var(--text-secondary)' },
  description: {
    fontSize: '12px',
    color: 'var(--text-secondary)',
    margin: 0,
    lineHeight: 1.5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
  },
  rollup: { fontSize: '11px', color: 'var(--text-secondary)' },
}
